const styles = (theme) => ({
  dialogText: {
    marginTop: theme.spacing.unit,
  },
});

export default styles;
